import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';

const buildCoordinates = (points, width, height) => {
  if (!points.length) {
    return [];
  }

  const maxScore = Math.max(...points.map(point => point.averageScore || 0), 100);
  const minScore = Math.min(...points.map(point => point.averageScore || 0), 0);
  const scoreRange = maxScore - minScore || 1;

  return points.map((point, index) => {
    const x = (index / (points.length - 1 || 1)) * width;
    const normalized = ((point.averageScore || 0) - minScore) / scoreRange;
    const y = height - (normalized * height);
    return { x, y };
  });
};

const TrendLineChart = ({ data = [], height = 140 }) => {
  const coordinates = useMemo(() => buildCoordinates(data, 320, height - 20), [data, height]);

  if (!data.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        Trend data will appear once learners complete scenarios in this range.
      </Typography>
    );
  }

  return (
    <Box sx={{ width: '100%', overflowX: 'auto' }}>
      <svg width={360} height={height} role="img" aria-label="Average score trend line">
        <polyline
          fill="none"
          stroke="#146C94"
          strokeWidth="3"
          strokeLinecap="round"
          points={coordinates.map(point => `${point.x},${point.y}`).join(' ')}
        />
        {coordinates.map((point, index) => {
          return (
            <g key={(data[index]?.bucket) || index}>
              <circle cx={point.x} cy={point.y} r={4} fill="#146C94" />
              <text x={point.x} y={height - 2} fontSize="10" textAnchor="middle" fill="#4b5563">
                {data[index]?.bucket}
              </text>
            </g>
          );
        })}
      </svg>
    </Box>
  );
};

export default TrendLineChart;
